// extracted by mini-css-extract-plugin
export default {"hideScrollbar":"ab2e3c8c","lineBreak":"cfe4df7b"};